import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const FinancialReports = lazy(() => import('./FinancialReports'));
const TradeReports = lazy(() => import('./TradeReports'));
const BalanceSheet = lazy(() => import('./BalanceSheet'));
const ProfitLoss = lazy(() => import('./ProfitLoss'));
const CashFlow = lazy(() => import('./CashFlow'));
const TrialBalance = lazy(() => import('./TrialBalance'));
const GeneralLedger = lazy(() => import('./GeneralLedger'));
const AgedReceivables = lazy(() => import('./AgedReceivables'));
const AgedPayables = lazy(() => import('./AgedPayables'));
const AIInsights = lazy(() => import('./AIInsights'));
const AIFinancialForecast = lazy(() => import('./AIFinancialForecast'));
const RevenueWaterfall = lazy(() => import('./RevenueWaterfall'));
const SegmentedPL = lazy(() => import('./SegmentedPL'));
const ChangesInEquity = lazy(() => import('./ChangesInEquity'));
const FixedAssetRegister = lazy(() => import('./FixedAssetRegister'));
const CustomReportBuilder = lazy(() => import('./CustomReportBuilder'));
const ConsolidatedReports = lazy(() => import('./ConsolidatedReports'));
const ReportSnapshots = lazy(() => import('./ReportSnapshots'));

const InventoryReports = lazy(() => import('./InventoryReports'));
const InventoryStock = lazy(() => import('./InventoryStock'));
const StockMovement = lazy(() => import('./StockMovement'));
const StockValuation = lazy(() => import('./StockValuation'));
const LowStock = lazy(() => import('./LowStock'));
const AIInventoryForecast = lazy(() => import('./AIInventoryForecast'));
const GRNIAging = lazy(() => import('./GRNIAging'));

export const reportsRoutes = (
    <React.Fragment key="reports">
        <Route element={<ProtectedRoute permission="finance.reports.view" />}>
            <Route path="/reports" element={<FinancialReports />} />
            <Route path="/reports/trade" element={<TradeReports />} />
            <Route path="/reports/balance-sheet" element={<BalanceSheet />} />
            <Route path="/reports/profit-loss" element={<ProfitLoss />} />
            <Route path="/reports/cash-flow" element={<CashFlow />} />
            <Route path="/reports/trial-balance" element={<TrialBalance />} />
            <Route path="/reports/general-ledger" element={<GeneralLedger />} />
            <Route path="/reports/aged-receivables" element={<AgedReceivables />} />
            <Route path="/reports/aged-payables" element={<AgedPayables />} />
            <Route path="/reports/grni-aging" element={<GRNIAging />} />
            <Route path="/reports/ai-insights" element={<AIInsights />} />
            <Route path="/reports/financial-forecast" element={<AIFinancialForecast />} />
            <Route path="/reports/revenue-waterfall" element={<RevenueWaterfall />} />
            <Route path="/reports/segmented-pl" element={<SegmentedPL />} />
            <Route path="/reports/equity" element={<ChangesInEquity />} />
            <Route path="/reports/fixed-assets" element={<FixedAssetRegister />} />
            <Route path="/reports/builder" element={<CustomReportBuilder />} />
            <Route path="/reports/custom-builder" element={<CustomReportBuilder />} />
            <Route path="/reports/consolidation" element={<ConsolidatedReports />} />
            <Route path="/reports/snapshots" element={<ReportSnapshots />} />
        </Route>
        <Route element={<ProtectedRoute permission="inventory.reports.view" />}>
            <Route path="/reports/inventory" element={<InventoryReports />} />
            <Route path="/reports/inventory-stock" element={<InventoryStock />} />
            <Route path="/reports/stock-movement" element={<StockMovement />} />
            <Route path="/reports/stock-valuation" element={<StockValuation />} />
            <Route path="/reports/low-stock" element={<LowStock />} />
            <Route path="/reports/inventory-forecast" element={<AIInventoryForecast />} />
        </Route>
    </React.Fragment>
);
